import { Progress } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import { Palette } from "../../core/styles/palette";

export const ProgressBar: FC = () => (
    <div style={{ marginTop: 16 }}>
        <Progress percent={100} status="active" showInfo={false} />
        <p style={{ textAlign: "center", marginTop: 8, color: Palette.Blue }}>{i18n.t("csvImport.modal.processing")}</p>
    </div>
);
